import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ComponentBehaviour } from "src/app/models/component-behaviour";
import { BaseError } from "../../../app/components/pages/base-error";
import { ComponentBehaviourService } from "../../services/component-behaviour/component-behaviour-service";
import { DeterminantControllerService } from "../../services/registration-controller/determinant-controller.service";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { LanguageControllerService } from "../../../app/services/language-controller/language-controller.service";
import { Store } from "../../../app/services/store.service";

@Component({
  selector: "determinant-triggers",
  templateUrl: "./determinant-triggers.component.html",
  providers: [ComponentBehaviourService, DeterminantControllerService],
})
export class DeterminantTriggersComponent extends BaseError implements OnInit {

  @Input() public serviceId: string;
  @Input() public determinantMapById: { [key: string]: string } = {};
  @Input() public behaviour: ComponentBehaviour = new ComponentBehaviour();

  public componentName: string;
  public componentKey: string;
  public componentDisabled: string;
  public componentHidden: string;
  public componentActivate: string;
  public componentCustomClass: string;
  public componentCustomClasses: any[] = [];
  public behaviourId: string;

  public readyForAction: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public behaviourService: ComponentBehaviourService,
    public determinantService: DeterminantControllerService,
    public translate: TranslateService,
    public toastr: ToastrService,
    public store: Store,
    languageService: LanguageControllerService,
  ) {
    super(toastr);
    translate.setDefaultLang(store.state.common.lang);
    languageService.getLanguages().subscribe(
      (data) => {
        translate.addLangs(data.map((l) => l.code));
      }
    );
  }

  public ngOnInit(): void {
    this.route.queryParamMap.subscribe((queryParams) => {
      if (queryParams.get("componentName")) { this.componentName = queryParams.get("componentName"); }
      if (queryParams.get("key")) { this.componentKey = queryParams.get("key"); }
      if (queryParams.get("hidden")) { this.componentHidden = queryParams.get("hidden"); }
      if (queryParams.get("disabled")) { this.componentDisabled = queryParams.get("disabled"); }
      if (queryParams.get("activate")) { this.componentActivate = queryParams.get("activate"); }
      if (queryParams.get("behaviourId")) { this.behaviourId = queryParams.get("behaviourId"); }
      if (queryParams.get("customClass")) { this.componentCustomClass = queryParams.get("customClass"); }
      if (queryParams.get("customClasses")) { this.componentCustomClasses = JSON.parse(queryParams.get("customClasses")); }
      console.log("--- determinant-triggers", this.componentCustomClass, this.componentCustomClasses);
      this.route.params.subscribe((params) => {
        this.serviceId = params.serviceId;
        this.loadBehaviour();
        if (!Object.keys(this.determinantMapById).length) {
          this.getServiceDeterminantKeyName();
        }
      });
    });
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public loadBehaviour() {
    if (this.behaviourId) {
      this.behaviourService.getBehaviour(this.behaviourId).subscribe((data) => {
        this.behaviour = data ? data : new ComponentBehaviour();
        if (!data) {
          this.behaviourId = null;
        }
        this.behaviour.serviceId = this.serviceId;
        this.behaviour.componentKey = this.componentKey;
        this.readyForAction = true;
      });
    } else if (this.serviceId && this.componentKey) {
      this.behaviourService.getBehaviourByServiceIdAndComponentKey(this.serviceId, this.componentKey)
        .subscribe((data) => {
          this.behaviour = data ? data : new ComponentBehaviour();
          if (!data) {
            this.behaviourId = null;
          }
          this.behaviour.serviceId = this.serviceId;
          this.behaviour.componentKey = this.componentKey;
          this.readyForAction = true;
          this.sendMessage();
        });
    } else {
      this.behaviour = new ComponentBehaviour();
      this.behaviour.serviceId = this.serviceId;
      this.behaviour.componentKey = this.componentKey;
      this.readyForAction = true;
    }
  }

  public saveBehaviourComponent(eff) {
    this.behaviour.effects = eff;
    /*if (this.behaviour.effects.length) {
      this.behaviour.effects.forEach((e) => {
        if (e.id?.startsWith("temp-")) {
          e.id = null;
        }
      });
    }*/
    if (this.behaviourId) {
      if (this.behaviour.effects?.length) {
        this.behaviourService.updateBehaviour(this.behaviour).subscribe((data) => {
          Object.assign(this.behaviour, data);
          this.sendMessage();
          this.sendSaveProcessingEvent(false);
          this.updateOrder();
        });
      } else {
        this.behaviourService.deleteBehaviour(this.behaviourId).subscribe((data) => {
          this.behaviourId = null;
          this.loadBehaviour();
          this.sendMessage();
          this.sendSaveProcessingEvent(false);
          this.updateOrder();
        });
      }
    } else {
      this.behaviourService.saveBehaviour(this.serviceId, this.behaviour).subscribe((data) => {
        if (data) {
          this.behaviourId = data.id;
          Object.assign(this.behaviour, data);
          this.sendMessage();
          this.sendSaveProcessingEvent(false);
          this.updateOrder();
        }
        console.log(data);
      });
    }
  }

  public updateOrder() {
    if (!this.behaviour.effects) {
      this.behaviour.effects = [];
    } else {
      this.behaviour.effects.sort((a, b) => {
        return a.sortOrderNumber - b.sortOrderNumber;
      });
    }
    console.log("--- Behaviour ---", this.behaviour);
  }

  public updateComponentProperty(e) {
    if (e) {
      switch (e.property) {
        case "hidden":
          this.updateHidden(e.value);
          break;
        case "disabled":
          this.updateDisabled(e.value);
          break;
        case "activate":
          this.updateActivate(e.value);
          break;
      }
    }
  }

  private updateHidden(hidden: boolean) {
    // Normalize current values
    this.componentCustomClass = (this.componentCustomClass || "").trim();
    this.componentCustomClasses = Array.isArray(this.componentCustomClasses) ? this.componentCustomClasses : [];

    if (hidden) {
      // Add "hide"
      if (!this.componentCustomClass.split(/\s+/).includes("hide")) {
        this.componentCustomClass = (this.componentCustomClass ? this.componentCustomClass + " " : "") + "hide";
      }
      if (!this.componentCustomClasses.includes("hide")) {
        this.componentCustomClasses.push("hide");
      }
    } else {
      // Remove "hide"
      this.componentCustomClass = this.componentCustomClass
        .replace(/\bhide\b/g, "")
        .replace(/\s+/g, " ")
        .trim();
      const idx = this.componentCustomClasses.indexOf("hide");
      if (idx > -1) {
        this.componentCustomClasses.splice(idx, 1);
      }
    }

    const message = {
      key: this.componentKey,
      changes: {
        customClass: this.componentCustomClass,
        customClasses: this.componentCustomClasses,
        hidden,
      },
    };
    const messageString: string = JSON.stringify(message);
    window.top.postMessage([{ channel: "FormBuilder", message: messageString }], "*");
  }

  private updateActivate(value) {
    if (value) {
      this.componentCustomClass?.replace("deactivated", "");
      this.componentCustomClasses?.splice(this.componentCustomClasses?.indexOf("deactivated"), 1);
    } else {
      if (!this.componentCustomClass?.includes("deactivated")) {
        this.componentCustomClass += " deactivated";
      }
      if (!this.componentCustomClasses?.find((c) => c === "deactivated")) {
        this.componentCustomClasses.push("deactivated");
      }
    }
    const message = {
      key: this.componentKey,
      changes: {
        customClass: this.componentCustomClass,
        customClasses: this.componentCustomClasses,
        activate: value,
      },
    };
    const messageString: string = JSON.stringify(message);
    window.top.postMessage([{ channel: "FormBuilder", message: messageString }], "*");
  }

  private updateDisabled(value) {
    const message = {
      key: this.componentKey,
      changes: {
        disabled: value,
      },
    };
    const messageString: string = JSON.stringify(message);
    window.top.postMessage([{ channel: "FormBuilder", message: messageString }], "*");
  }

  private sendMessage(): void {
    const message = {
      key: this.componentKey, count: this.behaviour.effects?.length || 0,
      changes: {
        behaviourId: this.behaviourId,
        effectsIds: this.behaviour.effects?.map((a) => a.id) || [],
      },
    };
    const messageString: string = JSON.stringify(message);
    window.top.postMessage([{ channel: "FormBuilder", message: messageString }], "*");
  }

  private sendSaveProcessingEvent(state = true) {
    window.top.postMessage([{ channel: "FormBuilder", message: JSON.stringify({ event: "saveProcessing", state }) }], "*");
  }

}
